import { Box, Dialog, Typography } from "@mui/material";
import { useContext, useEffect, useState } from "react";
import { ColorScheme } from "../../Themes/ColorScheme";
import { ApiContext } from "../ApiContext";
import { Spinner } from "../Common/Spinner";

import { isMobile } from "react-device-detect";
import { useTranslation } from "react-i18next";
import { MuiDrawer } from "../Common/MuiDrawer";
import { ClientOrderCard } from "./ClientOrderCard";
import { OrderDrawerContent } from "./OrderDrawerContent";

export const ClientOrders = ({ user, dialogOpen, closeDialog, location }) => {
	const { t } = useTranslation();
	const { ApiCall } = useContext(ApiContext);

	const [loading, setLoading] = useState(false);

	const [orders, setOrders] = useState([]);

	const [drawerContent, setDrawerContent] = useState(null);

	const fetchOrderData = () => {
		setLoading(true);
		ApiCall(
			"GET",
			`client/orders/${location.id}?user=${user.id} `
		)
			.then((res) => {
				setOrders(res);
				setLoading(false);
			})
			.catch(() => {
				// console.log(error);
				setLoading(false);
			});
	};

	const handleDrawerClose = () => {
		setDrawerContent(null);
	};

	const handleOrderSelect = (order) => {
		console.log("Selected order:", order);
		setDrawerContent({
			content: <OrderDrawerContent data={order} />,
			title: t("orders.order_label"),
			subtitle: "#" + order.order_id
		});
	};

	useEffect(() => {
		// console.log(dialogOpen);
		if (dialogOpen) {
			fetchOrderData();
		} else {
			setOrders([]);
		}
	}, [dialogOpen]);

	return (
		<div style={{ position: "relative" }}>
			<Dialog open={dialogOpen} onClose={() => closeDialog(null)}>
				<Box
					sx={{
						padding: "20px",
						minWidth: !isMobile ? "600px" : "300px",
						boxSizing: "border-box"
					}}
				>
					<Typography
						sx={{
							fontSize: "20px",
							color: ColorScheme.black,
							fontWeight: "700"
						}}
					>
						{user?.name}
					</Typography>
					<Typography sx={{ fontSize: "16px", color: ColorScheme.textSecondary }}>
						{user?.email}
					</Typography>
					<div style={{ height: "30px" }}></div>

					{loading && <Spinner color={ColorScheme.primary}></Spinner>}

					{orders.map((order, i) => (
						<ClientOrderCard
							key={i}
							closeDialog={closeDialog}
							setSelectedOrder={handleOrderSelect}
							data={order}
							user={user}
						/>
					))}
					<div style={{ height: "30px" }}></div>
					<Box
						sx={{
							flexDirection: "row",
							display: "flex",
							width: "100%",
							justifyContent: "space-between"
						}}
					>
						<Box
							onClick={() => closeDialog(null)}
							sx={{
								height: "40px",
								flex: 1,
								backgroundColor: ColorScheme.primary,
								cursor: "pointer",
								borderRadius: "4px",
								display: "flex",
								alignItems: "center",
								justifyContent: "center"
							}}
						>
							<Typography
								sx={{ fontSize: "14px", color: ColorScheme.textPrimary }}
							>
								{t("buttons.close")}
							</Typography>
						</Box>
					</Box>
				</Box>
			</Dialog>
			<MuiDrawer
				open={drawerContent !== null}
				handleDrawerClose={handleDrawerClose}
				subview={drawerContent && drawerContent.content}
				title={drawerContent && drawerContent.title}
				subtitle={drawerContent && drawerContent.subtitle}
			/>
		</div>
	);
};
